import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LoginPage from './pages/auth/LoginPage';
import DashboardPage from './pages/dashboard/DashboardPage';
import MainLayout from './components/layout/MainLayout';
import ProjectListPage from './pages/projects/ProjectListPage';
import ProjectCreatePage from './pages/projects/ProjectCreatePage';
import WorkLogPage from './pages/worklog/WorkLogPage';
import ExpensesPage from './pages/expenses/ExpensesPage';  // ⭐ 수정
import WorkLogApprovalPage from './pages/approvals/WorkLogApprovalPage';
import ExpenseApprovalPage from './pages/approvals/ExpenseApprovalPage';
import FinanceApprovalPage from './pages/finance/FinanceApprovalPage';  // ⭐ 수정
import FinanceExpensePage from './pages/finance/FinanceExpensePage';  // ⭐ 추가
import UserManagementPage from './pages/admin/UserManagementPage';
import DepartmentManagementPage from './pages/admin/DepartmentManagementPage';
import FinanceDashboardPage from './pages/finance/FinanceDashboardPage';
import ProjectTransactionPage from './pages/finance/ProjectTransactionPage';
import CorporateCardPage from './pages/finance/CorporateCardPage';
import AttendancePage from './pages/attendance/AttendancePage';
import AttendanceManagementPage from './pages/admin/AttendanceManagementPage';
import StrategicMeetingPage from './pages/strategic/StrategicMeetingPage';

// ProtectedRoute 컴포넌트
function ProtectedRoute({ children, allowedRoles = [] }) {
    const { isAuthenticated, user } = useSelector((state) => state.auth);

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    // 역할 확인
    if (allowedRoles.length > 0) {
        let userRoles = [];
        if (user.roles) {
            if (Array.isArray(user.roles)) {
                userRoles = [...user.roles];
            } else if (typeof user.roles === 'string') {
                try {
                    userRoles = JSON.parse(user.roles);
                } catch (e) {
                    userRoles = [];
                }
            }
        }
        if (user.role) userRoles.push(user.role);

        const hasPermission = allowedRoles.some(role => userRoles.includes(role));

        if (!hasPermission) {
            return <Navigate to="/dashboard" replace />;
        }
    }

    return <MainLayout>{children}</MainLayout>;
}

function App() {
    const { isAuthenticated } = useSelector((state) => state.auth);

    return (
        <Router>
            <Routes>
                {/* 로그인 페이지 */}
                <Route
                    path="/login"
                    element={isAuthenticated ? <Navigate to="/dashboard" /> : <LoginPage />}
                />

                {/* 대시보드 */}
                <Route
                    path="/dashboard"
                    element={
                        <ProtectedRoute>
                            <DashboardPage />
                        </ProtectedRoute>
                    }
                />

                {/* 프로젝트 */}
                <Route
                    path="/projects"
                    element={
                        <ProtectedRoute>
                            <ProjectListPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/projects/create"
                    element={
                        <ProtectedRoute allowedRoles={['admin', 'pm', 'manager']}>
                            <ProjectCreatePage />
                        </ProtectedRoute>
                    }
                />

                {/* 작업 일지 */}
                <Route
                    path="/worklog"
                    element={
                        <ProtectedRoute>
                            <WorkLogPage />
                        </ProtectedRoute>
                    }
                />

                {/* 개인 경비 */}
                <Route
                    path="/expenses"
                    element={
                        <ProtectedRoute>
                            <ExpensesPage />
                        </ProtectedRoute>
                    }
                />


                {/* PM 승인 */}
                <Route
                    path="/approvals/worklog"
                    element={
                        <ProtectedRoute allowedRoles={['admin', 'pm', 'manager']}>
                            <WorkLogApprovalPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/approvals/expense"
                    element={
                        <ProtectedRoute allowedRoles={['admin', 'pm', 'manager']}>
                            <ExpenseApprovalPage />
                        </ProtectedRoute>
                    }
                />

                {/* 재무 관리 */}
                <Route
                    path="/finance/dashboard"
                    element={
                        <ProtectedRoute allowedRoles={['admin', 'finance', 'pm', 'manager']}>
                            <FinanceDashboardPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/finance/transactions"
                    element={
                        <ProtectedRoute allowedRoles={['admin', 'finance', 'pm', 'manager']}>
                            <ProjectTransactionPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/finance/approval"
                    element={
                        <ProtectedRoute allowedRoles={['admin', 'finance']}>
                            <FinanceApprovalPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/finance/corporate-cards"
                    element={
                        <ProtectedRoute>
                            <CorporateCardPage />
                        </ProtectedRoute>
                    }
                />

                {/* 시스템 관리 */}
                <Route
                    path="/admin/users"
                    element={
                        <ProtectedRoute allowedRoles={['admin']}>
                            <UserManagementPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/admin/departments"
                    element={
                        <ProtectedRoute allowedRoles={['admin']}>
                            <DepartmentManagementPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/finance/attendance"
                    element={
                        <ProtectedRoute allowedRoles={['admin', 'manager']}>
                            <AttendanceManagementPage />
                        </ProtectedRoute>
                    }
                />

                {/* 전략회의 */}
                <Route
                    path="/strategic-meeting"
                    element={
                        <ProtectedRoute allowedRoles={['admin', 'pm', 'manager', 'finance']}>
                            <StrategicMeetingPage />
                        </ProtectedRoute>
                    }
                />

                {/* 기본 리다이렉트 */}
                <Route path="/" element={<Navigate to="/dashboard" />} />
                <Route path="*" element={<Navigate to="/dashboard" />} />
            </Routes>
        </Router>
    );
}

export default App;